export enum FancyTextPanels {
  DEFAULT = '',
  COLOR = 'color',
  SHADOW = 'shadow',
  INTRO_ANIMATION = 'intro-animation',
  OUTRO_ANIMATION = 'outro-animation',
}
